import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import countries from "../../constant/countries";

const FranchiseCountryDropdown = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (country) => {
    setShowDropdown(false);
    setSearchTerm("");
    navigate(`/pinkhelp/franchising-form/${country.name}`);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setShowDropdown((prev) => !prev)}
        className="px-6 py-3 border-2 border-green-500 rounded-lg text-lg font-semibold bg-white hover:bg-green-50 focus:outline-none"
      >
        🌍 Select Your Country
      </button>

      {showDropdown && (
        <div className="mt-2 w-80 max-h-80 overflow-y-auto bg-white border rounded shadow-lg">
          <input
            type="text"
            placeholder="Search country..."
            className="w-full p-2 border-b outline-none text-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <ul>
            {filteredCountries.map((country, idx) => (
              <li
                key={idx}
                onClick={() => handleSelect(country)}
                className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
              >
                <img
                  src={country.flag}
                  alt={country.name}
                  className="w-6 h-4 rounded-sm"
                />
                <span className="text-sm font-medium">{country.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FranchiseCountryDropdown
